<div class="iban-capture-container document-capture-container">
  <!-- <div class="info-container" *ngIf="document.isSubmitted === false">
  If you have your IBAN handy, you can enter it and we will start setting up
  your payment.
</div> -->
@if (document.isSubmitted === false) {
  <form [formGroup]="ibanForm">
    <div>
      <input
        formControlName="iban"
        (change)="onChange()"
        maxlength="31"
        type="text"
        id="iban"
        autocomplete="off"
        placeholder="Type Your IBAN"
        [ngClass]="{ 'invalid-iban': isInvalidIban }"
        />
        @if (isInvalidIban) {
          <span class="iban-message-validation"
            >Please check the IBAN again</span
            >
        }
      </div>
      @if (instructions) {
        <div id="instruction-container">
          <strong>Just make sure</strong><br />
          @for (instruction of instructions; track instruction) {
            <span
              >- {{ instruction }} <br
            /></span>
          }
        </div>
      }
      <!-- <div class="confirmation-container">
      <span>Tick the box if all that is correct</span
        ><input
        type="checkbox"
        name="confirmation-check"
        id="confirmation-check"
        />
      </div> -->
      <app-document-capture-footer
        [isSubmitted]="document.isSubmitted"
        [enableSubmitButton]="document.enableSubmitButton"
        (submitClicked)="onSubmit()"
      ></app-document-capture-footer>
    </form>
  }
</div>
